import { usePagesRedirect } from '@shared/hooks/use-pages-redirect.ts';

export const useArticleLargeCarPagedRedirect = () => {
  return usePagesRedirect('articleLargeCard');
};
